import React, {createContext, useEffect, useState} from "react";
import _ from "lodash";
import "src/locale/i18n";
import {HOSTS_CONFIG, THEMES} from "src/constants";
import {getI18n} from "react-i18next";

const defaultSettings = {
    direction: "ltr",
    responsiveFontSizes: true,
    theme: THEMES.LIGHT,
    language: null,
    logo: "register.it"
};

export const restoreSettings = () => {
    let settings = null;

    try {
        const storedData = window.localStorage.getItem("settings");

        if (storedData) {
            settings = JSON.parse(storedData);
        }
    } catch (err) {
        //console.error(err);
        // If stored data is not a strigified JSON this will fail,
        // that's why we catch the error
    }

    return settings;
};

export const storeSettings = settings => {
    window.localStorage.setItem("settings", JSON.stringify(settings));
};

const SettingsContext = createContext({
    settings: defaultSettings,
    saveSettings: () => {
    }
});

export const SettingsProvider = ({settings, children}) => {
    const [currentSettings, setCurrentSettings] = useState(settings || defaultSettings);
    const i18n = getI18n();
    const hostname = window.location.hostname;

    const handleSaveSettings = (update = {}) => {
        const mergedSettings = _.merge({}, currentSettings, update);
        setCurrentSettings(mergedSettings);
        storeSettings(mergedSettings);
        i18n.changeLanguage(mergedSettings.language);
    };

    useEffect(() => {
        const initSettings = restoreSettings() || currentSettings;
        initSettings.logo = _.get(HOSTS_CONFIG, `${hostname}`).brand || defaultSettings.logo;
        initSettings.language = initSettings.language || i18n.language;
        handleSaveSettings(initSettings);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        document.dir = currentSettings.direction;
    }, [currentSettings]);

    return (
        <SettingsContext.Provider
            value={{
                settings: currentSettings,
                saveSettings: handleSaveSettings
            }}
        >
            {children}
        </SettingsContext.Provider>
    );
};

export const SettingsConsumer = SettingsContext.Consumer;

export default SettingsContext;
